module.exports = __webpack_public_path__ + "static/media/coupon.cf02068b.svg";